export enum ReviewTab {
  SIMULATIONS = 'simulations',
  REAL_CALLS = 'real-calls',
}
